import BaseService from './base';
import request from '@/utils/request';

export interface TimelineItemViewModel {
  id?: number;
  name?: string;
  icon?: string;
  type?: number;
  dynasty?: number;
  introduce?: string;
  startYear?: number;
  endYear?: number;
  startMonth?: number;
  endMonth?: number;
  startDay?: number;
  endDay?: number;
  sourceUrl?: string;
  displayStart?: string;
  displayEnd?: string;
  isPublic: number;
}

export class TimelineItemService extends BaseService<TimelineItemViewModel> {
  protected serviceApi: string = 'TimelineItem';

  get NewModel(): TimelineItemViewModel {
    return {
      id: 0,
      name: '',
      isPublic: 1,
    };
  }

  public GetByName(name: string) {
    return request({
      url: `${this.serviceApi}/GetByName/${name}`,
      method: 'get',
    });
  }

  public GetTimelineData(condition: TimelineItemViewModel) {
    return request({
      url: `${this.serviceApi}/GetTimelineData`,
      method: 'post',
      data: condition,
    });
  }
}
